import { createComponent } from '@front/utils/alpine';
import { resolver } from '@front/utils/async';
import Cookies from 'js-cookie';
const [ready, resolveReady] = resolver();
const Newsletter = createComponent(() => ({
    isOpen: false,
    submitted: false,
    email: '',
    messageClass: '',
    errorMessage: '',
    isSubmitting: false,
    captchaMeta: null,
    captchaValue: '',
    ready,
    async init() {
        this.captchaMeta = document.querySelector('meta[name="google-captcha-public-key"]');
    },
    initCookie() {
        if (!Cookies.get('newcom_newsletter')) {
            let counter = Number(sessionStorage.getItem('newsletterCounter'));
            if (Number(counter) < 3) {
                window.addEventListener('click', () => {
                    sessionStorage.setItem('newsletterCounter', (counter++).toString());
                });
            }
            else {
                this.isOpen = true;
                sessionStorage.removeItem('newsletterCounter');
            }
        }
    },
    setCookie(register) {
        if (register) {
            Cookies.set('newcom_newsletter', 'registered', {
                expires: 365,
                sameSite: 'strict',
            });
        }
        else {
            Cookies.set('newcom_newsletter', 'notRegistered', {
                expires: 30,
                sameSite: 'strict',
            });
            this.isOpen = false;
        }
        sessionStorage.removeItem('newsletterCounter');
    },
    async submitForm(event, signalController) {
        event.preventDefault();
        this.isSubmitting = true;
        this.messageClass = '';
        this.errorMessage = '';
        if (this.captchaMeta !== null && this.captchaMeta.content) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.captchaMeta.content}`;
            script.onload = () => {
                grecaptcha.ready(() => {
                    resolveReady();
                });
            };
            document.body.appendChild(script);
        }
        if (event.target == undefined) {
            return;
        }
        try {
            await ready;
            this.captchaValue = await grecaptcha.execute(this.captchaMeta ? this.captchaMeta.content : '');
            await this.$nextTick();
            const formData = new FormData(event.target);
            const response = await fetch(event.target.action, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
                signal: signalController,
            });
            const data = await response.json();
            this.isSubmitting = false;
            if (data.success) {
                this.messageClass = 'text-state-success';
                this.setCookie(true);
                this.email = '';
                setTimeout(() => {
                    this.isOpen = false;
                }, 3000);
            }
            else {
                this.messageClass = 'text-state-error';
                this.errorMessage =
                    data.message ||
                        'Une erreur est survenue lors de votre inscription.';
            }
        }
        catch (error) {
            this.isSubmitting = false;
            this.messageClass = 'text-state-error';
            this.errorMessage =
                'Une erreur de réseau est survenue. Veuillez réessayer.';
        }
    },
}));
export { Newsletter };
